site.imageCaption = {
	// display image caption on top of image
	init: function() {
		$(window).on('load', function() {
			$('#main').find('.boxText img.mceAlignRight, .boxText img.mceAlignLeft').each(function () {
				let imageCaption = $(this).attr('title');
				if (imageCaption !== '' && imageCaption !== undefined) {
					let imgWidth = $(this).width();
					$("<span class='img-caption'><em>" + imageCaption +
						"</em></span>").css({
						'max-width': imgWidth + 'px',
						'width': '100%',
						'display': 'inline-block'
					}).insertAfter(this);
				}
			});
		});
	}
};

site.inits.push('site.imageCaption.init()');
